export default __webpack_public_path__ + "static/media/image5a.e40efc8f.png";